const state = {
  settings: {
    company_name: '翼鸿房产营销管家',
    company_logo: '',
    system_theme: 'default',
    client_to_public_days: 7,
    client_to_invalid_days: 30,
    notification_cleanup_days: 30,
    enable_email_notifications: true,
    enable_sms_notifications: false,
    auto_backup_enabled: true,
    backup_frequency: 'daily'
  },
  loading: false,
  saving: false
}

const mutations = {
  SET_SETTINGS(state, settings) {
    state.settings = { ...state.settings, ...settings }
  },

  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_SAVING(state, saving) {
    state.saving = saving
  },

  UPDATE_SETTING(state, { key, value }) {
    state.settings[key] = value
  }
}

const actions = {
  async fetchSettings({ commit }) {
    commit('SET_LOADING', true)
    try {
      // Simulate API call
      return state.settings
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateSettings({ commit }, settings) {
    commit('SET_SAVING', true)
    try {
      // Simulate API call
      const updatedSettings = { ...state.settings, ...settings }
      commit('SET_SETTINGS', updatedSettings)
      return updatedSettings
    } finally {
      commit('SET_SAVING', false)
    }
  },

  async uploadLogo({ commit }) {
    // Simulate file upload
    const logoUrl = '/placeholder-logo.png'
    commit('UPDATE_SETTING', { key: 'company_logo', value: logoUrl })
    return logoUrl
  }
}

const getters = {
  settings: state => state.settings,
  loading: state => state.loading,
  saving: state => state.saving,

  clientHandlingRules: state => ({
    toPublicDays: state.settings.client_to_public_days,
    toInvalidDays: state.settings.client_to_invalid_days
  }),

  backupSettings: state => ({
    enabled: state.settings.auto_backup_enabled,
    frequency: state.settings.backup_frequency
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}